class CountingNumber extends HTMLElement {
  constructor() {
	super();
	this.observer = null;
  }
  connectedCallback() {
	this.render();
	const sectionContainer = this.closest('.multicolumn__column');
	const observerOptions = {
	  root: null,
	  rootMargin: '0px',
	  threshold: 0.2
	};
	this.observer = new IntersectionObserver(this.handleIntersect.bind(this), observerOptions);
	this.observer.observe(sectionContainer);
  }
  disconnectedCallback() {
	if (this.observer) {
	  this.observer.disconnect();
	}
  }
  handleIntersect(entries) {
	entries.forEach(entry => {
	  if (entry.isIntersecting) {
		const countTo = this.dataset.count;
		const number = this.parseNumber(countTo);
		this.animateCount(0, number, 3000);
		this.observer.unobserve(entry.target);
	  }
	});
  }
  parseNumber(str) {
	if (str.includes('K') || str.includes("M")) {
	  return parseFloat(str) * 1;
	}
	return parseFloat(str);
  }
  animateCount(start, end, duration) {
	let startTime = null;
	const step = (currentTime) => {
	  if (!startTime) {
		startTime = currentTime;
	  }
	  const progress = currentTime - startTime;
	  const value = Math.min(Math.round(start + ((end - start) * (progress / duration))), end);
	  this.innerText = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + this.getSuffix(this.dataset.count);
	  if (progress < duration) {
		requestAnimationFrame(step);
	  }
	};
	requestAnimationFrame(step);
  }
  getSuffix(str) {
	const match = str.match(/[a-zA-Z+]+/g);
	return match ? match.join('') : '';
  }
  render() {
	const countTo = this.dataset.count;
	this.innerText = countTo;
  }
}

customElements.define('counting-number', CountingNumber);